import { Button, CircularProgress } from '@mui/material';

interface SecondaryActionProps {
  disabled?: boolean;
  loading?: boolean;
  onclick: (() => Promise<void>) | (() => void);
  label: string;
  id?: string;
  color?: 'secondary' | 'inherit' | 'primary' | 'success' | 'error' | 'info' | 'warning';
}

export const SecondaryAction = ({ disabled, loading, onclick, label, id, color }: SecondaryActionProps) => {
  return (
    <Button
      id={id}
      variant="outlined"
      color={color ?? 'secondary'}
      onClick={onclick}
      disabled={disabled}
      sx={{
        borderRadius: 1,
        textTransform: 'none',
      }}
      startIcon={loading ? <CircularProgress size={16} /> : null}
    >
      {label}
    </Button>
  );
};
